var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#001c33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 20,
    strokeWidth: 1.5,
    d: "M10.765 1.32v0L1.4 5.768v0l9.365 4.449v0l9.365-4.449v0L10.765 1.32v0zM1.4 14.66v0l9.365 4.448v0l9.365-4.448v0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#001c33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 20,
    strokeWidth: 1.5,
    d: "M1.4 10.21v0l9.365 4.448v0l9.365-4.448v0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#001c33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 20,
    strokeWidth: 1.5,
    d: "M10.765 1.32v0L1.4 5.768v0l9.365 4.449v0l9.365-4.449v0L10.765 1.32v0zM1.4 14.66v0l9.365 4.448v0l9.365-4.448v0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#001c33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 20,
    strokeWidth: 1.5,
    d: "M1.4 10.21v0l9.365 4.448v0l9.365-4.448v0"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIxIDIwIj48Zz48Zz48Zz48Zz48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDFjMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjIwIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTEwLjc2NSAxLjMydjBMMS40IDUuNzY4djBsOS4zNjUgNC40NDl2MGw5LjM2NS00LjQ0OXYwTDEwLjc2NSAxLjMydjB6Ii8+PC9nPjxnPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMWMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMjAiIHN0cm9rZS13aWR0aD0iMS41IiBkPSJNMS40IDE0LjY2djBsOS4zNjUgNC40NDh2MGw5LjM2NS00LjQ0OHYwIi8+PC9nPjxnPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMWMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMjAiIHN0cm9rZS13aWR0aD0iMS41IiBkPSJNMS40IDEwLjIxdjBsOS4zNjUgNC40NDh2MGw5LjM2NS00LjQ0OHYwIi8+PC9nPjwvZz48Zz48Zz48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDFjMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjIwIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTEwLjc2NSAxLjMydjBMMS40IDUuNzY4djBsOS4zNjUgNC40NDl2MGw5LjM2NS00LjQ0OXYwTDEwLjc2NSAxLjMydjB6Ii8+PC9nPjxnPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMWMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMjAiIHN0cm9rZS13aWR0aD0iMS41IiBkPSJNMS40IDE0LjY2djBsOS4zNjUgNC40NDh2MGw5LjM2NS00LjQ0OHYwIi8+PC9nPjxnPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMWMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMjAiIHN0cm9rZS13aWR0aD0iMS41IiBkPSJNMS40IDEwLjIxdjBsOS4zNjUgNC40NDh2MGw5LjM2NS00LjQ0OHYwIi8+PC9nPjwvZz48L2c+PC9nPjwvc3ZnPg==";
export { SvgListings as ReactComponent };